import SinglePropChainTracker from "../../../prop-tracker-utils/single-prop-chain-tracker.js";
import Mux from "../../../prop-tracker-utils/mux.js";
import ValueTrackerObjGen from "../../../prop-tracker-utils/value-tracker-obj-gen.js";

class ActiveEnvLightController {
    constructor(evtCtx, shlWrapCtx, shlEvtCtx) {
        this._evtCtx = evtCtx;
        this._shlWrapCtx = shlWrapCtx;
        this._shlEvtCtx = shlEvtCtx;

        this._slideEnvLightTracker = new SinglePropChainTracker(evtCtx);
        this._envLightMux = new Mux();

        this._envLightGen = new ValueTrackerObjGen(shlWrapCtx, shlEvtCtx, this._envLightMux);
    }

    get envLight() { return this._envLightGen; }

    track(slide, envLights) {
        if (slide) {
            this._slideEnvLightTracker.track(slide.data, ["value"]);
        } else {
            this._slideEnvLightTracker.track();
        }

        if (envLights) {
            this._envLightMux.setSource(envLights.data, envLights.events);
        } else {
            this._envLightMux.setSource();
        }
    }

    update() {
        this._slideEnvLightTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._envLightMux.setKey(newValue);
        });

        this._envLightGen.update();
    }
}

export default ActiveEnvLightController;
